import { render, staticRenderFns } from "./rsbz.vue?vue&type=template&id=660cfc32&scoped=true&"
import script from "./rsbz.vue?vue&type=script&lang=js&"
export * from "./rsbz.vue?vue&type=script&lang=js&"
import style0 from "./rsbz.vue?vue&type=style&index=0&id=660cfc32&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660cfc32",
  null
  
)

export default component.exports